module.exports = __webpack_public_path__ + "assets/img/5a86293aea35d6e2d0a0d73dafe10af4.png";